import { useTheme } from '@mui/material/styles';

export interface LogoProps {
  size?: number;
  /** Override the mark color (defaults to the brand accent). */
  color?: string;
}

/** Round Recon mark — a reticle/optic ring. Decorative; pair with a text label. */
export function Logo({ size = 22, color }: LogoProps) {
  const theme = useTheme();
  const t = theme.palette.tactical;
  const mark = color || t.accent;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      style={{ display: 'block' }}
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="11" cy="11" r="10" fill={mark} />
      <circle cx="11" cy="11" r="3" fill={t.bg} />
      <rect x="10" y="0" width="2" height="6" fill={t.bg} />
      <rect x="10" y="16" width="2" height="6" fill={t.bg} />
      <rect x="0" y="10" width="6" height="2" fill={t.bg} />
      <rect x="16" y="10" width="6" height="2" fill={t.bg} />
    </svg>
  );
}

export default Logo;
